var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntermediariesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3896 8.67004H25.7096V9.92004H24.3896V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0303 8.67004H28.3503V9.92004H27.0303V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4697 8.67004H17.7897V9.92004H16.4697V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8301 8.67004H15.1501V9.92004H13.8301V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19043 23.82H5.94043V19.89H9.21043V21.14H7.19043V23.82Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.72 11.31L21.09 0L12.21 4.87L12.81 5.96L21.09 1.42L39.12 11.31H3.06L10.56 7.2L9.96 6.11L0.46 11.31H0V42.27H4.55V18.5H28.35V17.25H1.25V12.56H40.94V17.25H30.34V18.5H37.64V42.27H42.19V11.31H41.73H41.72ZM3.3 41.02H1.25V18.5H3.3V41.02ZM40.93 41.02H38.88V18.5H40.93V41.02Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 6.65005C23.7002 5.21005 22.5302 4.05005 21.1002 4.05005C19.6702 4.05005 18.4902 5.22005 18.4902 6.65005C18.4902 8.08005 19.6602 9.26005 21.1002 9.26005C22.5402 9.26005 23.7002 8.09005 23.7002 6.65005ZM19.7402 6.65005C19.7402 5.90005 20.3502 5.29005 21.1002 5.29005C21.8502 5.29005 22.4602 5.90005 22.4602 6.65005C22.4602 7.40005 21.8502 8.01005 21.1002 8.01005C20.3502 8.01005 19.7402 7.40005 19.7402 6.65005Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6699 8.67004H30.9899V9.92004H29.6699V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1904 8.67004H12.5104V9.92004H11.1904V8.67004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59961 13.95H39.5696V15.2H2.59961V13.95Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1904 37.0601H16.4704V38.3101H11.1904V37.0601Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94043 27.8199V33.0699H7.19043V29.0699H11.2204V35.6699H16.4304V29.0699H20.4604V41.0299H7.19043V35.0499H5.94043V42.2799H28.3504V41.0299H21.7104V29.0699H25.7404V35.6699H30.9504V29.0699H34.9804V41.0299H30.3204V42.2799H36.2304V27.8299H5.94043V27.8199ZM15.1804 29.0699V31.7799H12.4704V29.0699H15.1804ZM12.4704 34.4199V33.0299H15.1804V34.4199H12.4704ZM29.7104 29.0699V31.7799H27.0004V29.0699H29.7104ZM27.0004 34.4199V33.0299H29.7104V34.4199H27.0004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.71 37.0601H30.99V38.3101H25.71V37.0601Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.96 19.89H36.28V21.14H34.96V19.89Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3203 19.89H33.6403V21.14H32.3203V19.89Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.18,
    height: 42.27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediariesIcon);
export default __webpack_public_path__ + "static/media/intermediaries-icon.f55b5cfbbb6e97e26c212e74a500a05b.svg";
export { ForwardRef as ReactComponent };